import { v4 as uuidv4 } from "uuid";

 const dataSlider = [
  {
    id: uuidv4(),
    title: "The Brotherhood Collection",
    subTitle: "Lorem"
  },
  {
    id: uuidv4(),
    title: "Based in Santa Cruz, CA",
    subTitle: "Lorem"
  },
  {
    id: uuidv4(),
    title: "Made in El Salvador",
    subTitle: "Lorem"
  },
  {
    id: uuidv4(),
    title: "",
    subTitle: "Lorem"
  },
  {
    id: uuidv4(),
    title: "",
    subTitle: "Lorem"
  },
];

export default dataSlider;


